import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class WebcontentExecuteService {

  constructor() { }

  public executeMethod(event: MessageEvent): any {
    const methodString: string = event.data.params;
    const parts: any = methodString.split("_")
    const methodName: string = parts[0];
    const methodData: string = parts[1];

    // The main logic is in Wordpress href of the executeMethod we can have the method name and data seprated by an underscore(_).
    const method = this[methodName];
    if (typeof method === 'function') return method.call(this, methodData);
    return console.error(`Method '${methodName}' not found or not a function, please check in the wordpress`);
    // you can create method with the methodName to execute the process for example exampleMethod.
  }

  protected exampleMethod(data?: string): any {
    //this is an example method.
    //Enter your code here.
  }
}
